export default "__VITE_ASSET__CF$qwjAp__"